module.exports = __webpack_public_path__ + "static/media/40-13.8b4acea3.mp3";